/*
 * Application State should be all within this file.
 */

const app = {
  state: {},
  mutations: {},
  actions: {
    // This action will be called when the app initializes to set the initial state
    initializeState({ dispatch, rootGetters }) {
      console.log("VUEX Initializing state...");
      let sections = rootGetters["getSections"];
      if (sections.length > 0) {
        let firstStepId = sections[0].steps[0].id;
        dispatch("setCurrentStepId", firstStepId, { root: true });
      }
    },
    mapFromDatastore({ dispatch }, payload) {
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      // Go through each key in stepValues and commit individually
      if (_payload?.stepValues) {
        for (const [id, value] of Object.entries(_payload.stepValues)) {
          dispatch("setStepData", { id, value }, { root: true });
        }
      }

      if (_payload?.progressStepId && _payload.progressStepId !== "") {
        console.log("Setting progressStepId to:", _payload.progressStepId);
        dispatch("setCurrentStepId", _payload.progressStepId, { root: true });
      } else {
        dispatch("initializeState");
      }
    }
  },
  getters: {
    mapToDatastore(state, getters, rootState, rootGetters) {
      let stepValues = rootGetters["getStepValues"];
      let progressStepId = rootGetters["getProgressStepId"];

      let payload = {
        stepValues: stepValues,
        progressStepId: progressStepId
      };

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
